/**
 * Indicateur d'état d'un message façon WhatsApp :
 *   ✓        gris   — envoyé (le message a un id serveur)
 *   ✓✓       gris   — livré à au moins un destinataire (`livre_a` contient un autre user)
 *   ✓✓       bleu   — lu par au moins un destinataire (`lu_par` contient un autre user)
 *
 * S'utilise UNIQUEMENT sur mes propres messages (mine=true) — sans effet sur les autres.
 */
import React from 'react';

interface Props {
  mine: boolean;
  myUserId: number | null;
  livre_a?: number[];
  lu_par?: number[];
  /** true si le drawer est en dark-mode (nécessaire pour ajuster gris) */
  isDark?: boolean;
}

export const ChatCheckMarks: React.FC<Props> = ({
  mine, myUserId, livre_a, lu_par, isDark = false,
}) => {
  if (!mine) return null;
  const uid = myUserId ?? -1;
  const livreAutres = (livre_a || []).some(id => id !== uid);
  const luAutres = (lu_par || []).some(id => id !== uid);

  const grey = isDark ? '#93A0AE' : '#8A96A3';
  const blue = '#3B82F6';
  const color = luAutres ? blue : grey;

  return (
    <span
      title={luAutres ? 'Lu' : livreAutres ? 'Reçu' : 'Envoyé'}
      className="inline-block align-middle ml-0.5"
      style={{ lineHeight: 0 }}
    >
      {livreAutres || luAutres ? (
        // ✓✓ Double check
        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 5.5l2.3 2.3L8 3.1" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          <path d="M5.5 5.5l2.3 2.3L14 1.4" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </svg>
      ) : (
        // ✓ Single check
        <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 5.5l3 3L11 1.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </svg>
      )}
    </span>
  );
};

export default ChatCheckMarks;
